

































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { storeRiwayat } from "@/store/modules/riwayat";
import { storeCopy } from "@/store/modules/copy";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import DateFormat from "@/utility/DateFormat";
import { isEmpty } from "lodash";
import AsesmenAwalGadar from "@/services/AsesmenAwalGadar/AsesmenAwalGadar";
import { caraPulangOptions } from "@/utility/DataReferensi";
import {
  DetailRiwayat,
  DiagnosaRanapItem,
  RiwayatDetailBundle,
  RiwayatDetailEntry
} from "@/types/riwayat";
import { EMPTY_DETAIL_RIWAYAT } from "@/utils/riwayatDrawer";
import { SoapResponseItem } from "@/types/soap";
import {
  AdimeResponseItem,
  HandoverResponseItem,
  ReadbackResponseItem
} from "@/types/cppt";
import AsesmenAwalRanapMedis from "@/services/AsesmenAwalRanapMedis";
import http from "@/axios/http-common";
import SvcAsesmenKemoterapi from "@/services/AsesmenKemoterapi";
import ResumeCetakMenu from "@/components/resume/ResumeCetakMenu.vue";

@Component({
  components: { ResumeCetakMenu }
})
export default class CardDetailRiwayat extends Vue {
  @Prop({ required: true }) register: string | number;
  isResepPanelOpen = null;

  mounted() {
    storeRiwayat.loadDetail(this.register);
  }

  get stateuser() {
    return userModule.user;
  }

  get entry(): RiwayatDetailEntry | undefined {
    return storeRiwayat.detailByRegister[String(this.register)];
  }

  get bundle(): RiwayatDetailBundle | null {
    return this.entry?.bundle ?? null;
  }

  get isLoading() {
    return !this.entry || this.entry.status === "loading";
  }

  get errorMessage() {
    return this.entry?.status === "error" ? this.entry.error : null;
  }

  get diagnosaRanap(): DiagnosaRanapItem[] {
    return this.bundle?.diagnosa_ranap ?? [];
  }

  get detailriwayat(): DetailRiwayat {
    return this.bundle?.detail ?? EMPTY_DETAIL_RIWAYAT;
  }

  retry() {
    storeRiwayat.loadDetail(this.register);
  }

  get soapList(): SoapResponseItem[] {
    let list = [];

    if (
      this.detailriwayat?.soap_dokter.length ||
      this.detailriwayat?.soap_perawat.length
    ) {
      list = [
        ...this.detailriwayat.soap_dokter,
        ...this.detailriwayat.soap_perawat
      ].sort((a, b) => {
        return (
          new Date(b.examined_at).getTime() - new Date(a.examined_at).getTime()
        );
      });
    }

    return list;
  }

  // Ketiga getter di bawah WAJIB `.slice()` sebelum `.sort()`: Vue 2.6 mem-patch
  // Array.prototype.sort sehingga mengurutkan array reaktif di dalam getter
  // memicu dep.notify() -> render loop tanpa pemutus arus di build produksi.
  get adimeList(): AdimeResponseItem[] {
    return (this.bundle?.adime ?? [])
      .slice()
      .sort((a, b) => this.waktuDesc(a.examined_at, b.examined_at));
  }

  get handoverList(): HandoverResponseItem[] {
    return (this.bundle?.handover ?? [])
      .slice()
      .sort((a, b) => this.waktuDesc(a.transferred_at, b.transferred_at));
  }

  get readbackList(): ReadbackResponseItem[] {
    return (this.bundle?.readback ?? [])
      .slice()
      .sort((a, b) => this.waktuDesc(a.consulting_at, b.consulting_at));
  }

  waktuDesc(a: string, b: string) {
    return new Date(b).getTime() - new Date(a).getTime();
  }

  // Relasi dipancarkan lewat whenLoaded() sehingga bisa null pada record lama.
  nama(user: { nama?: string }) {
    return user?.nama ?? "-";
  }

  namaUnit(unit: { nama?: string }) {
    return unit?.nama ?? "-";
  }

  canCopySoap(soap: SoapResponseItem) {
    return (
      this.stateuser.profesi == "Dokter" &&
      this.stateuser.id == parseInt(soap.user.id)
    );
  }

  get isAnyRiwayat() {
    return (
      this.detailriwayat.soap_dokter?.length > 0 ||
      this.detailriwayat.soap_perawat?.length > 0 ||
      this.isAnyAsesmen ||
      this.adimeList.length > 0 ||
      this.handoverList.length > 0 ||
      this.readbackList.length > 0
    );
  }

  get isAnyAsesmenGadar() {
    return !isEmpty(this.asesmenMedisGadar);
  }

  get isAnyAsesmen() {
    return (
      this.detailriwayat["asesmen_awal_ralan"]?.length > 0 ||
      this.detailriwayat["asesmen_awal_gigi_mulut"]?.length > 0 ||
      this.isAnyAsesmenGadar ||
      this.detailriwayat["asesmen_awal_ranap_medis"] ||
      this.detailriwayat["asesmen_kemoterapi"]
    );
  }

  get isAnyResume() {
    return (
      this.detailriwayat["resume_ralan"] || this.detailriwayat["resume_ranap"]
    );
  }

  get asesmenMedisGadar() {
    return this.bundle?.asesmen_gadar ?? null;
  }

  get contentRiwayatAsesmenGadar() {
    return {
      keluhanUtama: this.asesmenMedisGadar?.content?.anamnesis?.keluhanUtama,
      diagnosisKerja: this.asesmenMedisGadar?.content?.diagnosis?.kerja,
      terapi: this.asesmenMedisGadar?.content?.terapi?.terapi,
      caraPulang: this.asesmenMedisGadar?.content?.tindakLanjut?.caraPulang,
      dokter: this.asesmenMedisGadar?.content?.dokter
    };
  }

  get showCopyAllBtn() {
    return this.stateuser.profesi == "Dokter" && this.stateuser.unit_id != "01";
  }

  get showKonsulTitle() {
    return this.konsulList.length > 0;
  }

  get konsulList() {
    return this.detailriwayat["konsul"]?.filter(it => it.unit_tujuan);
  }

  copySoapDokter(val) {
    appModule.NoticeDelay("SOAP " + val.user.nama + " Berhasil Disalin");
    storeCopy.act_copy_soap(val);
  }

  copySoapPerawat(val) {
    appModule.NoticeDelay("SOAP " + val.user.nama + " Berhasil Disalin");
    storeCopy.act_copy_soap(val);
  }

  copyDiagnosa(val) {
    appModule.NoticeDelay("Diagnosa Berhasil Disalin");
    storeCopy.act_copy_diagnosa(val);
  }

  copyResep(val) {
    appModule.NoticeDelay("Resep Berhasil Disalin");
    storeCopy.act_copy_resep(val);
  }

  copyOrderLab(val) {
    appModule.NoticeDelay("Order Laboratorium Berhasil Disalin");
    storeCopy.act_copy_lab(val);
  }

  copyOrderRadiologi(val) {
    appModule.NoticeDelay("Order Radiologi Berhasil Disalin");
    storeCopy.act_copy_ro(val);
  }

  formatTgl(tgl) {
    return tgl ? DateFormat.formatDate(tgl) : null;
  }

  copyAll(soap, diag, resep) {
    if (diag.length > 0) {
      this.copyDiagnosa(diag);
    }
    if (resep.length > 0) {
      for (const i in resep) {
        if (soap.user.id == resep[i].dokter.id) {
          this.copyResep(resep[i]);
        }
      }
    }
    if (soap != undefined) {
      this.copySoapDokter(soap);
    }
    appModule.NoticeDelay("Catatan " + soap.user.nama + " Berhasil Disalin");
  }

  asesmen(link) {
    window.open(link, "_blank");
  }

  replace(val) {
    return val.replace("(SORE)", "");
  }

  asesmenGigi(link) {
    window.open(link, "_blank");
  }
  asesmenRanapMedis(id) {
    AsesmenAwalRanapMedis.print(id);
  }
  asesmenKemoterapi(id) {
    SvcAsesmenKemoterapi.print(id);
  }
  resumeRalan(id) {
    const routeData = http.getAPI() + "/resume-ralan-paket/" + id + "/pdf";
    window.open(routeData, "_blank");
  }

  printAsesmenAwalGadar(regId) {
    console.log("print asesmen awal gadar");
    AsesmenAwalGadar.printByRegister(regId);
  }

  getCaraPulangText(id: number) {
    const plg = caraPulangOptions.find(item => item.id == id);

    return plg?.name ?? "-";
  }

  copyInstant(soap, diag, resep) {
    if (diag.length > 0) {
      storeCopy.act_copy_diagnosa_instant(diag);
    }
    if (resep.length > 0) {
      for (const i in resep) {
        if (soap.user.id == resep[i].dokter.id) {
          // this.copyResep(resep[i]);
          storeCopy.act_copy_resep_instant(resep[i]);
        }
      }
    }
    if (soap != undefined) {
      storeCopy.act_copy_soap_instant(soap);
    }
  }
}
